// @flow

import clsx from 'clsx';

import { Fqdn, Text } from '@gandi/ui';

import { Icon } from 'src/Domain/Icon';

import styles from './ResultRow.scss';

type Props = {
  iconName: 'available' | 'available_secondary' | 'unavailable',

  /** statusText is the text displayed next to the icon */
  statusText: string,

  fqdn: string,

  pricingBlock: React.Node,
};

export const ResultRow = ({
  iconName,
  statusText,
  fqdn,
  pricingBlock,
}: Props): React.MixedElement => {
  return (
    <div
      className={clsx(
        styles.root,
        iconName === 'unavailable' ? styles.grey : styles.white,
      )}
    >
      <div className={styles.description}>
        <div className={styles.status}>
          <Icon iconName={iconName} variant="compact" />
          <Text weight="semibold" className={styles['status-text']}>
            {statusText}
          </Text>
        </div>
        <Fqdn size="big">{fqdn}</Fqdn>
      </div>
      {!!pricingBlock && <div className={styles.pricing}>{pricingBlock}</div>}
    </div>
  );
};
